import {createSelector} from 'reselect';
import getBasketContainsNonSubscriptionProduct from '../../getBasketContainsNonSubscriptionProduct';
import getBasketContainsSubscriptionProduct from '../../getBasketContainsSubscriptionProduct';
import {getSettings} from '../../selectors';

export default createSelector(
  [getSettings, getBasketContainsSubscriptionProduct, getBasketContainsNonSubscriptionProduct],
  (settings, basketContainsSubscriptionProduct, basketContainsNonSubscriptionProduct) => {
    let blockedAdyenSubTypes = settings?.adyen_v2_blocked_sub_types || [];
    const blockedAdyenSubTypesForSubscriptions = settings?.adyen_v2_blocked_sub_types_for_subscriptions || [];
    const blockedAdyenSubTypesForNonSubscriptions = settings?.adyen_v2_blocked_sub_types_for_non_subscriptions || [];
    
    if (basketContainsSubscriptionProduct) {
      const combinedBlockedArray = [...blockedAdyenSubTypes, ...blockedAdyenSubTypesForSubscriptions];
      blockedAdyenSubTypes = Array.from(new Set(combinedBlockedArray));
    }
  
    if (basketContainsNonSubscriptionProduct) {
      const combinedBlockedArray = [...blockedAdyenSubTypes, ...blockedAdyenSubTypesForNonSubscriptions];
      blockedAdyenSubTypes = Array.from(new Set(combinedBlockedArray));
    }
    
    return blockedAdyenSubTypes;
  },
);
